export { default as useEffectOnce } from './useEffectOnce';
export * from './useEffectOnce';
//# sourceMappingURL=index.js.map